<div class="top">
  <a href="/dashboard">
    <img class="logo" [src]="tenantConfigService.desktopLogoUrl"
         [alt]="tenantConfigService.config.productName + ' logo'"/>
  </a>

  <hfc-logout-button *ngIf="logoutButton"></hfc-logout-button>
</div>

<hfc-progress-bar
  *ngIf="showProgressBar"
  [value]="percentageCompleted"
  [showValue]="false"
  [radius]="false"
></hfc-progress-bar>

<div *ngIf="!showProgressBar" class="bottom"></div>
